/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AsReportedSecurityBreakdownForDeletion } from '../models/as-reported-security-breakdown-for-deletion';
@Injectable({
  providedIn: 'root',
})
class AsReportedSecurityBreakdownService extends __BaseService {
  static readonly deleteAsReportedSecurityBreakdownPath = '/asReportedSecurityBreakdown';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param asReportedSecurityBreakdown undefined
   * @return delete the asReportedSecurityBreakdown, response will be true if deleted successfully
   */
  deleteAsReportedSecurityBreakdownResponse(asReportedSecurityBreakdown: AsReportedSecurityBreakdownForDeletion): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = asReportedSecurityBreakdown;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/asReportedSecurityBreakdown`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param asReportedSecurityBreakdown undefined
   * @return delete the asReportedSecurityBreakdown, response will be true if deleted successfully
   */
  deleteAsReportedSecurityBreakdown(asReportedSecurityBreakdown: AsReportedSecurityBreakdownForDeletion): __Observable<boolean> {
    return this.deleteAsReportedSecurityBreakdownResponse(asReportedSecurityBreakdown).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module AsReportedSecurityBreakdownService {
}

export { AsReportedSecurityBreakdownService }
